import { useScriptStore } from '@/shared/store/script.store.ts'
import { useSpeechStore } from '@/shared/store/speech.store.ts'
import useTracksStore from '@/shared/store/tracks.store.tsx'
import type { SessionDto } from '@/features/session/data/dto/session.dto.ts'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url.ts'
import useMediaStore from '@/shared/store/media.store.tsx'
import type { Clip } from '@/features/clips/domain/models/clip.ts'

const loadMediaForClips = async (
  tracks: Array<{ clips: Clip[] }>
): Promise<void> => {
  const { addMedia } = useMediaStore.getState()
  for (const clip of tracks.flatMap(({ clips }) => clips)) {
    if (!clip.src) {
      console.error(`No src found for clip ${clip.id}`)
      continue
    }
    const audioBuffer = await getAudioBufferFromAudioUrl(clip.src)
    addMedia(clip.mediaId, audioBuffer)
  }
}

export const loadSession = async ({ state }: SessionDto): Promise<void> => {
  const { version, scripts, speeches, timeline } = state ?? {}
  if (!version || version !== 'v0.1') {
    console.error(
      `Unsupported session state version: ${version ?? 'undefined'}`
    )
    return
  }

  if (scripts) {
    const { storeScript } = useScriptStore.getState()
    for (const script of scripts) {
      storeScript({
        ...script,
        lastUpdate: new Date(script.lastUpdate),
      })
    }
  }

  if (speeches) {
    const { storeSpeeches } = useSpeechStore.getState()
    storeSpeeches(speeches)
  }

  if (timeline) {
    const { setSnapshot } = useTracksStore.getState()
    setSnapshot(timeline)
    await loadMediaForClips(timeline.tracks)
    const hasClips = timeline.tracks.some(({ clips }) => clips.length > 0)
    useTracksStore.setState({ isMixEmpty: !hasClips })
  }
}
